<template>
  <path pid="0" d="M22 18.5a3.5 3.5 0 10-3.5 3.5 3.5 3.5 0 003.5-3.5zM18.5 20a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zM4 7.5A3.5 3.5 0 107.5 4 3.5 3.5 0 004 7.5zm5 0A1.5 1.5 0 117.5 6 1.5 1.5 0 019 7.5zM19.29 5.29l-14 14a1 1 0 001.42 1.42l14-14a1 1 0 10-1.42-1.42z"/>
</template>
